export function validatePricingVehiclePayload(payload) {
  if (!payload?.name?.trim()) {
    return "El nombre es obligatorio.";
  }

  if (payload.name.trim().length > 40) {
    return "El nombre no debe exceder 40 caracteres.";
  }

  if (
    payload?.maxPersonNational === "" ||
    payload?.maxPersonNational === null ||
    payload?.maxPersonNational === undefined
  ) {
    return "La capacidad maxima nacional es obligatoria.";
  }

  if (Number(payload.maxPersonNational) < 1) {
    return "La capacidad maxima nacional debe ser minimo 1.";
  }

  if (
    payload?.maxPersonInternational === "" ||
    payload?.maxPersonInternational === null ||
    payload?.maxPersonInternational === undefined
  ) {
    return "La capacidad maxima internacional es obligatoria.";
  }

  if (Number(payload.maxPersonInternational) < 1) {
    return "La capacidad maxima internacional debe ser minimo 1.";
  }

  if (!payload?.serviceBooking) {
    return "El tipo de servicio es obligatorio.";
  }

  if (Number(payload.serviceBooking) !== 1 && Number(payload.serviceBooking) !== 2) {
    return "El tipo de servicio es invalido.";
  }

  if (
    payload?.priceBase === "" ||
    payload?.priceBase === null ||
    payload?.priceBase === undefined
  ) {
    return "El precio base es obligatorio.";
  }

  if (Number(payload.priceBase) < 5) {
    return "El precio base debe ser minimo 5.00.";
  }

  if (
    payload?.multiplier === "" ||
    payload?.multiplier === null ||
    payload?.multiplier === undefined
  ) {
    return "El multiplicador es obligatorio.";
  }

  if (Number(payload.multiplier) < 1) {
    return "El multiplicador debe ser minimo 1.00.";
  }

  if (typeof payload?.active !== "boolean") {
    return "El estado activo es obligatorio.";
  }

  return null;
}
